import {periodToDateFrom, periodToDateTo} from "@/lib/periodToDates";

export default {

    methods: {
        getDateStore(storeGetterName) {
            const dateRange = this.$store.getters[storeGetterName];

            return {
                rangeName: dateRange.rangeName ? dateRange.rangeName : 'Today',
                fromDate: periodToDateFrom(
                    dateRange.rangeName ? dateRange.rangeName : 'Today',
                    dateRange.fromDate
                ),
                toDate: periodToDateTo(
                    dateRange.rangeName ? dateRange.rangeName : 'Today',
                    dateRange.toDate
                ),
            }
        }
    },
}
